import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ViewWillEnter } from '@ionic/angular';
import { ModalController } from '@ionic/angular';
import { EmployeeListService } from '../../../../common/services/employee-listing.service'; 
import { RequestParams } from '../../../../common/rest-api/models/request-params';
import { GarmentReportService } from '../../services/garment-report.service';
import { DepartmentKey } from '../../../../../app/common/models/department-key-model';
import { GtrakAuthService } from '../../../../../app/features/authentication/services/gtrak-auth.service';
import { GarmentWeeklyHistoryModalComponent } from '../../components/garment-weekly-history-modal/garment-weekly-history-modal.component';
import { EmployeeListing } from '../../../../common/models/employee-listing.model';
import _ from "lodash";



@Component({
  selector: 'app-department-garment-report-page',
  templateUrl: 'department-garment-report.page.html',
  styleUrls: [
    './department-garment-report.page.scss',
  ]
})
export class DepartmentGarmentReportPage implements ViewWillEnter, OnInit {

  departmentId: string;
  customerId: string;

  requestParams: any;
  activePrintId: string | null = null;
  isAllPrint:boolean=false;
  results: any;

  currentPage: number;
  pageSize: number;
  reports: any;
  totalPages: number;
  totalRecords: number;
  pageNumbers = [];

  depKey: DepartmentKey;

  printing: boolean = false;
  currentDate:Date;
  selectedRowKey: string = null;
  loaded:Boolean=false;
  public viewChange: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private employeeListService: EmployeeListService,
    private garmentReportService: GarmentReportService,
    private authService: GtrakAuthService,
     private modalController: ModalController,
    
  ) { 
  }

  ngOnInit(): void {
    this.loaded=false;
    if(!this.authService.user.canViewGarmentListing) {
      this.router.navigate([this.authService.user.homeLocation]);
    }
    var estDate=new Date(new Date());
    this.currentDate = estDate;
    this.loaded=true;
  }

  ionViewWillEnter(): void {
    this.departmentId = this.route.snapshot.paramMap.get('id');
    this.customerId = this.route.snapshot.paramMap.get('cid');

    this.depKey = {
      CustomerCode: this.customerId,
      DepartmentCode: this.departmentId
    };

    this.currentPage = 1;
    this.pageSize = 10;

    this.requestParams = new RequestParams();
    this.requestParams.setOrdering('LastName', 'asc');

    this.requestParams.setPaging(this.currentPage, this.pageSize);

    this.setData();
  }

  async setData(): Promise<void> {
    this.loaded=false;
    this.results = await this.garmentReportService.findForDepartment(this.depKey, this.requestParams);
    if(this.results!=undefined){
      _.each(this.results.results, (gr) => {
        gr.notes = gr.notes.filter((test, index, array) =>
          index === array.findIndex((find) => find.code === test.code)
        );
      })

    _.each(this.results.results, (result) => {
      result.summaryNotes = [];
      _.each(result.summary, (sum) => {
        if(sum.status=="1"|| sum.status=="10" || sum.status=="11" ||sum.status=="4"||sum.status=="8"||sum.status=="9" ) {
          if(sum.status.length > 0) {
            result.summaryNotes.push({
              'status': sum.status,
              'statusDesc': sum.statusDesc
            })
          }
        }
      });
    result.summaryNotes = result.summaryNotes.filter((test, index, array) =>
        index === array.findIndex((find) => find.status === test.status)
      );
    });
    

    this.reports = this.results.results;
    this.totalPages = this.results.totalPages;
    this.totalRecords = this.results.totalRecords;

    this.pageNumbers = Array(this.totalPages).fill(1).map((x, i) => i)
    this.pageNumbers.push(this.totalPages);
    
  }
  this.loaded=true;
}

  selectPage(number: number): void {
    if(number <= 0) return;

    this.currentPage = number;

    this.requestParams.setPaging(this.currentPage, this.pageSize);

    this.selectedRowKey = null;

    this.setData();
  }

  goTo(location: string): void {
    window.location.hash = '';
    window.location.hash = location;
  }

  changePrinterView(): void {
     this.isAllPrint=true;
    this.viewChange = !this.viewChange;
    setTimeout(() => {
      print();
    }, 1000); 
  }
printGarmentReport(id: string): void {
  this.activePrintId = id;
  this.isAllPrint=false;
  this.viewChange = !this.viewChange;

  setTimeout(() => {
    window.print();
  }, 500);
}

  clearFilterByRowKey(): void {
    this.selectedRowKey = null;
  }

  filterByRowKey(key: string): void {
    this.selectedRowKey = key;
  }

  print() {
    this.printing = true;
    setTimeout(() => {
      window.print();
    },1);
  }
   async openWeeklyHistoryModal(employee: EmployeeListing): Promise<void> {
  const modal = this.modalController.create({
                 component: GarmentWeeklyHistoryModalComponent,
                 componentProps: {
                   'employee': employee
                 },
                 cssClass: "min-width-modal-md",
                 showBackdrop: true,
                 backdropDismiss: true,
                 keyboardClose: true,
                 swipeToClose: true,
               
               });
          (await modal).present();
             const {data} = await (await modal).onDidDismiss();
 
 
   }
 
openWorkOrder(data){
  
        this.router.navigate(['/work-order/employee/' + data.employeeCode + '/' + data.customerCode + '/' + data.departmentCode]); 
}
}